import { AfterViewInit, Component, ElementRef, EventEmitter, Input, OnDestroy, Output, ViewChild } from '@angular/core';
import { EditorView } from 'codemirror';
import { QueryEditorService } from 'src/app/language-service/query-editor.service';
import { SharedService } from 'src/app/services/shared.service';
import { AlertsvarService } from '../alertsvar.service';

@Component({
  selector: 'alert-query-editor',
  templateUrl: './alert-query-editor.component.html',
  styleUrls: ['./alert-query-editor.component.scss']
})

export class AlertQueryeditorComponent implements AfterViewInit, OnDestroy{

  @Input() builtInquery = "";
  // @Input() query_platform = "";
  @Input() alertId:any;
  query_platform="firewall_fortigate"
  @Output() changedQuery = new EventEmitter();
  @ViewChild('editorcontainer', { static: true }) editorcontainer: ElementRef<HTMLElement>;
  @Input() readonly:boolean = false;
  editor: EditorView;

  constructor(
    public alertvarservice:AlertsvarService,
    private queryEditorService:QueryEditorService,
    private sharedService:SharedService
  ){}


  setLanguageGrammar(platform:string,alertId:string){
    this.sharedService.getruleLanguageGrammar(platform,alertId)
      .then((platform_plugins:object)=>{
        this.queryEditorService.processFields([])
        // this.queryEditorService.setExternalTokens(platform_plugins['external_tokens'],platform_plugins['suggestion_rules'],platform_plugins['tokens_map_json'],platform_plugins['platform_fields'])
        this.createeditor(this.builtInquery,platform_plugins['grammar']);

      })
      .catch((err)=>{console.log(err)})
  }

  ngAfterViewInit(): void {
//console.log("AlertId",this.alertId)
    this.setLanguageGrammar(this.query_platform,this.alertId)

   
  }

  createeditor(builtInquery:string,grammar:string){
    let query = builtInquery.replace(/ AND /g, ' AND\n').replace(/ OR /g, ' OR\n');
    if(this.alertvarservice.ruleConditionEditor){
      this.alertvarservice.ruleConditionEditor.destroy();
//console.log("Destroyed")
    }
    this.alertvarservice.ruleConditionEditor = this.queryEditorService.initializeEditor(this.editorcontainer.nativeElement,query,this.readonly,grammar);
//console.log("RuleConditionEditor>>>>>>>>>>>",this.alertvarservice.ruleConditionEditor,"BuiltIn \n",this.builtInquery)
    this.queryEditorService.set_editor_value(this.alertvarservice.ruleConditionEditor,this.builtInquery)
    

  }
  

  geteditorvalue(){
    return this.queryEditorService.get_editor_value(this.alertvarservice.ruleConditionEditor);
  }

  ngOnDestroy(): void {
//console.log("Alert query editor destroyed")
    this.alertvarservice.isInvalid=true
    this.queryEditorService.set_editor_value(this.alertvarservice.ruleConditionEditor,'')
    this.changedQuery.emit(this.queryEditorService.get_editor_value(this.alertvarservice.ruleConditionEditor));
    this.alertvarservice.ruleConditionEditor.destroy();
  }
  onInputLiveChange(event: Event) {
      let newValue = (event.target as HTMLInputElement).value;
      let change=(event.target as HTMLElement).innerText
      let queryChange=""
      this.alertvarservice.isInvalid=true
      // console.log("Is Editor Error -->",this.queryEditorService.isEditorError(this.alertvarservice.ruleConditionEditor))
      // this.queryEditorService.set_editor_value(this.alertvarservice.ruleConditionEditor,change)
      // console.log("From Query Service-->",this.queryEditorService.get_editor_value(this.alertvarservice.ruleConditionEditor))

      // this.queryEditorService.editorValue$.subscribe(data=>{
      //   console.log("ONvalueChanges ---->",data)
      //   queryChange=data
        // console.log("Conditions 5.1",this.alertvarservice.autoInvestigate.value.conditions)
        // this.changedQuery.emit(queryChange);
        // console.log("Get Editor----->",this.queryEditorService.get_editor_value(this.alertvarservice.ruleConditionEditor))
      // })
      
      
      // this.changedQuery.emit(this.queryEditorService.get_editor_value(this.alertvarservice.ruleConditionEditor));
      // this.changedQuery.emit(queryChange);

      if(this.alertvarservice.isInvalid){
        this.alertvarservice.conditionsValid=false
      }
      // else{
      //   this.alertvarservice.conditionsValid=true
      // }
//console.log('Input value changed live:', queryChange,this.alertvarservice.conditionsValid);
   
    }
}
